package com.ives.utils;

import haxe.macro.Context;
import haxe.macro.Expr;

class ConfigBuilder {
	public static function build():Array<Field> {
		var p = Context.resolvePath("config.properties");

		Context.registerModuleDependency(Context.getLocalModule(), p);

		var string:String = sys.io.File.getContent(p);

		var lines:Array<String> = string.split("\n");

		var fields:Array<Field> = Context.getBuildFields();

		for(line in lines)
			if(line.indexOf("=") != -1){
				var parts:Array<String> = line.split("=");

				var key:String = StringTools.trim(parts[0]);
				var name:String = StringTools.replace(key.toUpperCase(), ".", "_");
				var value:String = StringTools.trim(parts[1]);

				if(value == "true" || value == "false"){
					var boolean:Bool = (value == "true");

					fields.push({
						name: name,
						doc: '${key} = ${value}',
						access: [Access.APublic, Access.AStatic, Access.AInline],
						kind: FieldType.FVar(macro:Bool, macro $v{boolean}),
						pos: Context.currentPos()
					});
				}
				else{
					fields.push({
						name: name,
						doc: '${key} = ${value}',
						access: [Access.APublic, Access.AStatic, Access.AInline],
						kind: FieldType.FVar(macro:String, macro $v{value}),
						pos: Context.currentPos()
					});
				}
			}

		return fields;
	}
}
